import { FC } from 'react'
import { useLiveQuery } from 'dexie-react-hooks'
import { IonGrid } from '@ionic/react'
import { QuizScoreSection } from '@mytours/components'
import { ScreenSection } from 'mytours-read-common'
import db from 'mobile_web/modules/db'
import strings from 'mobile_web/strings'
import { getDirMode } from '../../../platform'
import SectionHeader from './SectionHeader'
import '../styles/sectionQuizScore.less'

interface SectionQuizScoreProps {
	section: ScreenSection
}

const SectionQuizScore: FC<SectionQuizScoreProps> = ({ section }) => {
	const { quiz_id: quizId } = section
	const questionsLength = useLiveQuery(
		() => (quizId ? db.quizQuestions.where({ quiz_id: quizId }).count() : 0),
		[quizId],
	)
	const correctAnswersLength = useLiveQuery(
		() => (quizId ? db.quizResults.filter(result => result.quiz_id === quizId && result.correct).count() : 0),
		[quizId],
	)

	return (
		<IonGrid className="section-quiz-score" dir={getDirMode()}>
			<SectionHeader title={strings.quiz_score_section_title} />
			<QuizScoreSection
				className="block-content"
				dir={getDirMode()}
				dataCy="story-screen-section"
				label={strings.quiz_score_section_score_label}
				correctAnswers={correctAnswersLength ?? 0}
				totalQuestions={questionsLength ?? 0}
				icon={<i className="fal fa-award" />}
			/>
		</IonGrid>
	)
}

export default SectionQuizScore
